import { useUserStore } from "@/stores/user";

export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.startsWith("/h5/") || !to.meta.requiresAuth) return;

  const userStore = useUserStore();
  if (userStore.isLoggedIn) return;

  return navigateTo(
    {
      path: "/h5/supply-mall",
      query: {
        login: "1",
        redirect: to.fullPath,
      },
    },
    { replace: true },
  );
});
